import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Button,
  IconButton,
  Typography,
  TextField,
  Select,
  MenuItem,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { getData, postData } from "../../../ServerRequest";
//import { DataGrid } from '@mui/x-data-grid';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import LandscapeIcon from "@mui/icons-material/Landscape";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
//import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
//import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

export default function CreateBatch(props) {
  const [loading, setLoading] = useState(true);
  const [tagsData, setTagsData] = useState([]);
  const [liveTags, setLiveTagsData] = useState([]);
  const [familyData, setFamilyData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [selectedBatchCategory, setSelectedBatchCategory] = useState("");
  const [isCreatingBatchCategory, setIsCreatingBatchCategory] = useState(false);
  //const [newBatchCategory, setNewBatchCategory] = useState("");
  const [selectedBatchFamily, setSelectedBatchFamily] = useState("");
  const [isCreatingBatchFamily, setIsCreatingBatchFamily] = useState(false);
  //const [newBatchFamily, setNewBatchFamily] = useState("");
  const [batchVisibility, setBatchVisibility] = useState({});
  const [imageUrl, setImageUrl] = useState(null);
  const [batchAction, setBatchAction] = useState("");
  const [batchTagName, setBatchTagName] = useState("");
  const [batchImage, setBatchImage] = useState("");
  const [batchCreatedBy, setBatchCreatedBy] = useState(null);
  const [batchUpdatedBy, setBatchUpdatedBy] = useState(null);
  const [batchStatus, setBatchStatus] = useState([]);

  const resetBatchForm = () => {
    setBatchAction("");
    setBatchTagName("");
    setBatchImage("");
    setImageUrl(null);
    setBatchCreatedBy(null);
    setBatchUpdatedBy(null);
    setBatchStatus([]);
    setSelectedBatchCategory("");
    setSelectedBatchFamily("");
    setIsCreatingBatchCategory(false);
    setIsCreatingBatchFamily(false);
    setBatchVisibility({});
  };

  // Utility: Convert image file to base64
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  // Batch Action: Merge
  const handleBatchMerge = async () => {
    if (!batchTagName || !selectedBatchCategory || !selectedBatchFamily) {
      alert("Please provide a name, category, and family for the merged tag.");
      setLoading(false);
      return;
    }
    try {
      for (const tag of props.selectedRows) {
        if (!tag.id) continue;
        const resData = {
          'id': tag.id,
          'product_tag': tag.product_tag,
          'category': tag.tag_category,
          'tag_family': tag.tag_family,
          'status': 0, // deleted
          'is_assigned': false,
        };
        await postData("/api/product/acc_tag_master", resData);
      }
    } catch (err) {
      setLoading(false);
      alert("Failed to update selected tags to deleted status.");
      console.error("Error updating tags to deleted:", err);
      return;
    }
    // Create the new merged tag
    let reqData = {
      'product_tag': batchTagName,
      'category': selectedBatchCategory,
      'tag_family': selectedBatchFamily,
      'image_url': imageUrl ? imageUrl : "",
      'status': 1,
      'is_assigned': true,
    };
    if (batchCreatedBy) reqData.created_by = batchCreatedBy;
    if (batchUpdatedBy) reqData.updated_by = batchUpdatedBy;
    Object.keys(reqData).forEach((key) => {
      if (
        reqData[key] === undefined ||
        reqData[key] === null ||
        reqData[key] === ""
      ) {
        delete reqData[key];
      }
    });
    if (batchImage) {
      reqData.image_url = await convertToBase64(batchImage);
    } else if (imageUrl) {
      reqData.image_url = imageUrl;
    }
    try {
      const resData = await postData("/api/product/acc_tag_master", reqData);
      if (resData["data"]["code"] === "200") {
        alert("Batch merge applied successfully.");
        const updatedData = await getData("/api/product/acc_tag_master");
        setTagsData(updatedData.data.tags);
        resetBatchForm();
        if (props.onBatchActionComplete) {
          const sortDesc = (arr) =>
            Array.isArray(arr)
              ? [...arr].sort((a, b) => {
                  const aDate = new Date(a.updated_on || a.created_at || 0);
                  const bDate = new Date(b.updated_on || b.created_at || 0);
                  return bDate - aDate;
                })
              : [];
          const sortedData = {
            ...updatedData.data,
            live_tags: sortDesc(updatedData.data.live_tags),
            archived_tags: sortDesc(updatedData.data.archived_tags),
            deleted_tags: sortDesc(updatedData.data.deleted_tags),
          };
          props.onBatchActionComplete(sortedData);
        }
      } else {
        alert("Failed to create merged tag.");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error creating merged tag:", error);
      alert("An error occurred while creating the merged tag.");
    } finally {
      setLoading(false);
    }
  };

  // Batch Action: Delete
  const handleBatchDelete = async () => {
    const tagsToDelete = props.selectedRows.filter((tagObj) => tagObj.id);
    if (!tagsToDelete.length) {
      setLoading(false);
      return;
    }
    try {
      for (const tag of tagsToDelete) {
        const resData = {
          'id': tag.id,
          'product_tag': tag.product_tag,
          'category': tag.tag_category,
          'tag_family': tag.tag_family,
          'status': 0,
          'is_assigned': false,
        };
        const res = await postData("/api/product/acc_tag_master", resData);
        if (res["data"]["code"] === "200") {
          alert("Success in deleting tags: " + tag.product_tag);
          setLoading(false);
          return;
        }
      }
      alert("Selected tags deleted successfully.");
      const updatedData = await getData("/api/product/acc_tag_master");
      setTagsData(updatedData.data.tags);
      resetBatchForm();
      props.onBatchActionComplete && props.onBatchActionComplete();
    } catch (err) {
      setLoading(false);
      alert("Failed to delete selected tags.");
      console.error("Error deleting tags:", err);
      return;
    } finally {
      setLoading(false);
    }
  };

  // Batch Action: Archive
  const handleBatchArchive = async () => {
    const tagsToArchive = props.selectedRows.filter((tagObj) => tagObj.id);
    if (!tagsToArchive.length) {
      setLoading(false);
      return;
    }
    try {
      for (const tag of tagsToArchive) {
        const resData = {
          'id': tag.id,
          'product_tag': tag.product_tag,
          'category': tag.tag_category,
          'tag_family': tag.tag_family,
          'status': 2,
          'is_assigned': false,
        };
        const res = await postData("/api/product/acc_tag_master", resData);
        if (res["data"]["code"] === "200") {
          alert("Success in archiving tags: " + tag.product_tag);
          setLoading(false);
          return;
        }
      }
      alert("Selected tags archived successfully.");
      const updatedData = await getData("/api/product/acc_tag_master");
      setTagsData(updatedData.data.tags);
      resetBatchForm();
      props.onBatchActionComplete && props.onBatchActionComplete();
    } catch (err) {
      setLoading(false);
      alert("Failed to archive selected tags.");
      console.error("Error archiving tags:", err);
      return;
    } finally {
      setLoading(false);
    }
  };

  // Batch Action: Remove Assigned
  const handleBatchRemoveAssigned = async () => {
    const tagsToUpdate = props.selectedRows.filter((tagObj) => tagObj.id);
    if (!tagsToUpdate.length) {
      setLoading(false);
      return;
    }
    try {
      for (const tag of tagsToUpdate) {
        const resData = {
          'id': tag.id ? tag.id : "",
          'product_tag': tag.product_tag ? tag.product_tag : "",
          'category': tag.tag_category ? tag.tag_category : "",
          'tag_family': tag.tag_family ? tag.tag_family : "",
          'status': 1,
          'is_assigned': false,
        };
        const res = await postData("/api/product/acc_tag_master", resData);
        if (res["data"]["code"] === "200") {
          alert("Success in updating tags: " + tag.product_tag);
          setLoading(false);
          return;
        }
      }
      alert("Selected tags updated to not assigned.");
      const updatedData = await getData("/api/product/acc_tag_master");
      setTagsData(updatedData.data.tags);
      resetBatchForm();
      props.onBatchActionComplete && props.onBatchActionComplete();
    } catch (err) {
      setLoading(false);
      alert("Failed to update selected tags.");
      return;
    } finally {
      setLoading(false);
    }
  };

  // Main handler
  const handleBatchSubmit = async () => {
    if (!batchAction) {
      alert("Please select a batch action.");
      return;
    }
    if (props.selectedRows.length === 0) {
      alert("No rows selected for batch action.");
      return;
    }
    setLoading(true);
    if (batchAction === "Merge") {
      await handleBatchMerge();
    } else if (batchAction === "Delete") {
      await handleBatchDelete();
    } else if (batchAction === "Archived") {
      await handleBatchArchive();
    } else if (batchAction === "Remove assigned") {
      await handleBatchRemoveAssigned();
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      try {
        let familyRes = await getData("/api/product/acc_tag_family");
        //console.log(familyRes);
        let family_data = familyRes["data"]["tag_families"];
        if (family_data) {
          console.log(family_data);
          setFamilyData(family_data);
        } else {
          console.error("Error fetching tags family data:", familyRes.message);
        }

        let categoryRes = await getData("/api/product/acc_tag_category");
        //console.log(categoryRes);
        let category_data = categoryRes["data"]["tag_categories"];
        if (category_data) {
          console.log(category_data);
          setCategoryData(category_data);
        } else {
          console.error(
            "Error fetching tags category data:",
            categoryRes.message
          );
        }

        let masterRes = await getData("/api/product/acc_tag_master");
        //console.log(masterRes);
        let master_data = masterRes["data"]["tag_masters"];
        let live_tags = masterRes["data"]["live_tags"];
        if (master_data) {
          console.log(master_data);
          setTagsData(live_tags);
          setLiveTagsData(live_tags);
        } else {
          console.error("Error fetching tag master data:", masterRes.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  const handleBatchActionChange = (event) => {
    setBatchAction(event.target.value);
  };

  const handleBatchTagNameChange = (event) => {
    setBatchTagName(event.target.value);
  };

  /* const handleCreateNewBatchCategory = () => {
        setIsCreatingBatchCategory(true);
    };

    const handleCreateNewBatchFamily = () => {
        setIsCreatingBatchFamily(true);
    };

    const handleBatchCategoryChange = (event) => {
        setSelectedBatchCategory(event.target.value);
    };


    const handleBatchFamilyChange = (event) => {
        setNewBatchFamily(event.target.value);
    };

    const handleBatchCategorySubmit = (e) => {
        if (e.key === "Enter" && newBatchCategory.trim() !== "") {
            const newBatchCategoryObj = {
                id: categoryData.length + 1, // Simple ID assignment
                category: newBatchCategory.trim(),
            };

            setCategoryData([...categoryData, newBatchCategoryObj]); // Add new category to list
            setSelectedBatchCategory(newBatchCategoryObj.id); // Select the new category
            setIsCreatingBatchCategory(false); // Close input field
        } else if (e.key === "Escape") {
            setIsCreatingBatchCategory(false); // Cancel category creation on Escape key
        }
    };

    const handleBatchFamilySubmit = (e) => {
        if ((e.type === "keydown" && e.key === "Enter") || e.type === "click") {
            if (newBatchFamily.trim() !== "") {
                const newBatchFamilyObj = {
                    id: familyData.length + 1,
                    tag_family: newBatchFamily.trim(),
                };

                setFamilyData([...familyData, newBatchFamilyObj]); // Add new family
                setSelectedBatchFamily(newBatchFamilyObj.id); // Select new family
                setIsCreatingBatchFamily(false); // Hide input field
                setNewBatchFamily(""); // Reset input
            }
        }
    }; */

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const img = new Image();
      const imageUrl = URL.createObjectURL(file);
      img.src = imageUrl;
      img.onload = () => {
        if (img.width === 120 && img.height === 60) {
          setImageUrl(imageUrl); // Set the image URL for preview
          setBatchImage(file);
          console.log("Batch image uploaded successfully:", file);
          // You can use tagImageUrl for preview if needed
        } else {
          alert("Image must be exactly 120px wide and 60px tall.");
          URL.revokeObjectURL(imageUrl); // Free up memory
        }
      };
      img.onerror = () => {
        alert("Failed to load image. Please try again.");
        URL.revokeObjectURL(imageUrl); // Free up memory
      };
    }
  };

  const toggleBatchVisibility = (tag) => {
    setBatchVisibility((prev) => ({ ...prev, [tag]: !prev[tag] }));
  };

  return (
    <Box sx={{ width: "100%", mt: 2, mb: 5 }}>
      <Grid container sx={{ flex: 1, height: "100%" }}>
        <Box sx={{ width: "100%", height: "100%" }}>
          <Accordion
            expanded={props.expanded}
            onChange={(_, expanded) => props.setExpanded(expanded)}
            selectedRows={props.selectedRows}
            sx={{
              backgroundColor: "#F8F9FA",
              mt: 2,
              borderRadius: 0,
              boxShadow: 0,
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{
                p: { xs: 2, sm: 4 },
                pt: 0,
                pb: 0,
                gap: { xs: 1, sm: 2 },
                height: { xs: 48, sm: 58 },
                alignItems: "center",
                justifyContent: "space-between",
                display: "flex",
              }}
            >
              <Typography
                variant="body1"
                sx={{ fontFamily: "Inter", fontWeight: "700", fontSize: 16 }}
              >
                Create batch actions of tags
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                p: 4,
                pt: 0,
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Grid container spacing={2} sx={{ mb: 1 }}>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#171A1F",
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: 14,
                      mt: 1,
                    }}
                  >
                    Tag selected = {props.selectedRows.length}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <FormGroup row sx={{ display: "flex-row" }}>
                    {props.selectedRows.map((tag) => (
                      <Box
                        key={tag}
                        sx={{ display: "flex", alignItems: "center", mt: 1 }}
                      >
                        <Checkbox
                          checked={true} // Initially checked since it's a selected row
                          onChange={() => props.onToggleRow(tag)} // Call a handler to toggle selection
                          sx={{ padding: 0, marginRight: 1 }}
                        />
                        <Typography
                          key={tag}
                          variant="body2"
                          sx={{
                            fontFamily: "Inter",
                            fontWeight: 700,
                            fontSize: 14,
                            mt: 1,
                          }}
                        >
                          {tag} &nbsp;&nbsp;
                        </Typography>
                      </Box>
                    ))}
                  </FormGroup>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                {/* Batch Action */}
                <Grid item xs={12} sm={6} md={3}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#424956",
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: 14,
                    }}
                  >
                    {" "}
                    Batch Action{" "}
                  </Typography>
                  <Select
                    size="small"
                    value={batchAction}
                    onChange={handleBatchActionChange}
                    sx={{
                      width: "193px",
                      height: "35px",
                      borderRadius: "0px",
                      backgroundColor: "#fff",
                    }}
                  >
                    <MenuItem value="Merge">Merge</MenuItem>
                    <MenuItem value="Delete">Delete</MenuItem>
                    <MenuItem value="Archived">Archived</MenuItem>
                    <MenuItem value="Remove assigned">Remove assigned</MenuItem>
                  </Select>
                </Grid>

                {/* Define Name*/}
                <Grid item xs={12} sm={6} md={3}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#424956",
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: 14,
                    }}
                  >
                    {" "}
                    Define name{" "}
                  </Typography>
                  <TextField
                    size="small"
                    placeholder="Create a new name"
                    sx={{
                      width: "193px",
                      "& .MuiOutlinedInput-root": {
                        height: "35px",
                        borderRadius: "0px",
                        backgroundColor: "#fff",
                      },
                    }}
                    value={batchTagName}
                    onChange={handleBatchTagNameChange}
                  />
                </Grid>

                {/* Select Category */}
                <Grid item xs={12} sm={6} md={3}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#424956",
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: 14,
                    }}
                  >
                    {" "}
                    Select Category{" "}
                  </Typography>
                  {isCreatingBatchCategory ? (
                    {
                      /* <TextField
                                            size="small"
                                            sx={{ minWidth: "193px", fontSize: 14, "& .MuiOutlinedInput-root": { height: "35px", borderRadius: "0px", backgroundColor: '#fff' } }}
                                            value={newBatchCategory}
                                            onChange={handleBatchCategoryChange}
                                            onKeyDown={handleBatchCategorySubmit}
                                            autoFocus
                                            placeholder="Enter new category"
                                        /> */
                    }
                  ) : (
                    <Select
                      size="small"
                      sx={{
                        minWidth: "193px",
                        height: "35px",
                        borderRadius: "0px",
                        backgroundColor: "#fff",
                      }}
                      value={selectedBatchCategory}
                      onChange={(event) =>
                        setSelectedBatchCategory(event.target.value)
                      }
                    >
                      {/* <MenuItem onClick={handleCreateNewBatchCategory} value="" sx={{ border: "1px solid #bcc1ca", fontSize: 14 }}>
                                                <AddCircleOutlineIcon sx={{ fontSize: 15, mr: 1 }} />
                                                Create a new Category
                                            </MenuItem> */}
                      {categoryData.map((category, index) => (
                        <MenuItem
                          key={category.id}
                          value={category.id}
                          sx={{ fontSize: 14 }}
                        >
                          {category.category}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                </Grid>

                {/* Select Family */}
                <Grid item xs={12} sm={6} md={3}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#424956",
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: 14,
                    }}
                  >
                    {" "}
                    Select Family{" "}
                  </Typography>
                  {isCreatingBatchFamily ? (
                    {
                      /* <TextField
                                            size="small"
                                            sx={{ minWidth: "193px", fontSize: 14, "& .MuiOutlinedInput-root": { height: "35px", borderRadius: "0px", backgroundColor: '#fff' } }}
                                            value={newBatchFamily}
                                            onChange={handleBatchFamilyChange}
                                            onKeyDown={handleBatchFamilySubmit}
                                            autoFocus
                                            placeholder="Enter new family"
                                        /> */
                    }
                  ) : (
                    <Select
                      size="small"
                      sx={{
                        minWidth: "193px",
                        height: "35px",
                        borderRadius: "0px",
                        backgroundColor: "#fff",
                      }}
                      value={selectedBatchFamily}
                      onChange={(event) =>
                        setSelectedBatchFamily(event.target.value)
                      }
                    >
                      {/* <MenuItem onClick={handleCreateNewBatchFamily} value="" sx={{ border: "1px solid #bcc1ca", fontSize: 14 }}>
                                                <AddCircleOutlineIcon sx={{ fontSize: 15, mr: 1 }} />
                                                Create a new Family
                                            </MenuItem> */}
                      {familyData.map((family, index) => (
                        <MenuItem
                          key={family.id}
                          value={family.id}
                          sx={{ fontSize: 14 }}
                        >
                          {family.tag_family}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                </Grid>

                {/* Upload Section */}
                <Grid item xs={12} sm={6} md={3}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#424956",
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: 14,
                    }}
                  >
                    {" "}
                    Add Image{" "}
                  </Typography>
                  <Box sx={{ display: "flex" }}>
                    <FormGroup column>
                      {props.selectedRows.map((tag) => (
                        <div
                          key={`image-${tag}`}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox sx={{ transform: "scale(0.8)" }} />
                            }
                            label={tag}
                          />
                          <IconButton
                            onClick={() => toggleBatchVisibility(tag)}
                          >
                            <VisibilityOutlinedIcon
                              style={{
                                color: [tag] ? "black" : "gray",
                                width: "20px",
                                height: "20px",
                              }}
                            />
                          </IconButton>
                        </div>
                      ))}
                    </FormGroup>
                  </Box>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#424956",
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: 14,
                      mb: 1,
                    }}
                  >
                    {" "}
                    Upload New image{" "}
                  </Typography>
                  <input
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    id="upload-button"
                    onChange={handleImageUpload}
                  />
                  <Box
                    sx={{
                      mt: 0.5,
                      width: 120,
                      height: 60,
                      border: "1px solid #FAFAFB",
                      backgroundColor: "#F3F4F6",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {imageUrl ? (
                      <img
                        src={imageUrl}
                        alt="Uploaded"
                        style={{ width: "100%", height: "100%" }}
                      />
                    ) : (
                      <LandscapeIcon sx={{ color: "#BCC1CA" }} />
                    )}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mt: 1,
                      width: 120,
                    }}
                  >
                    <label style={{ fontSize: "13px", color: "black" }}>
                      Upload Image (120x60px)
                    </label>
                    <IconButton
                      component="label"
                      size="small"
                      sx={{ color: "#000" }}
                    >
                      <FileUploadOutlinedIcon />
                      <input
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={handleImageUpload}
                      />
                    </IconButton>
                  </Box>
                </Grid>
              </Grid>

              {/* Save Button */}
              <Box>
                <Button
                  variant="outlined"
                  sx={{
                    width: "307px",
                    height: "44px",
                    backgroundColor: "#565E6D",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#546e7a" },
                    borderRadius: "0px",
                    mt: 4,
                  }}
                  onClick={handleBatchSubmit}
                >
                  Save
                </Button>
              </Box>
            </AccordionDetails>
          </Accordion>
        </Box>
      </Grid>
    </Box>
  );
}
